import * as React from 'react';
import SimpleSelect from './SimpleSelect';
var YEARS = [
    '2010',
    '2011',
    '2012',
    '2013',
    '2014',
    '2015',
    '2016',
    '2017',
    '2018',
    '2019',
    '2020',
    '2021',
    '2022',
    '2023',
    '2024',
    '2025',
    '2026',
    '2027',
    '2028',
    '2029',
    '2030',
    '2031',
    '2032',
    '2033',
    '2034',
    '2035',
    '2036',
    '2037',
    '2038',
    '2039',
];
function YearPicker(props) {
    var error = props.error, value = props.value, onChange = props.onChange;
    return (React.createElement(SimpleSelect, { includeBlank: true, error: error, value: value, items: YEARS, onChange: onChange }));
}
export default YearPicker;
